import {Component, OnInit} from '@angular/core';
import {NavMenuItem} from '../../models/nav-menu-item.model';
import {User} from '../../models/user.model';

@Component({
  selector: 'app-nav-menu',
  templateUrl: 'nav-menu.component.html',
  styleUrls: ['nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {

  public isNavbarCollapsed: boolean;
  public items: NavMenuItem[] = [];

  constructor() {
    this.isNavbarCollapsed = true;
    this.items = NavMenuItem.getForUser();
    User.logout$.merge(User.login$).subscribe(() => this.items = NavMenuItem.getForUser());
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/nav-menu/nav-menu.component.ts